// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyLocationWithHiddenAddress",
    "PropertyLocationWithVisibleAddress"
  ]);
}

let fragmentConverter = {"__root":{"propertyLocation":{"u":"fragment_propertyLocation"},"activeOnMlsSince":{"b":""},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_propertyLocation: unwrap_fragment_propertyLocation
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationDisplay",
      "storageKey": null
    },
    "action": "THROW"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuietPropertyMatchPopup_forSalePropertyV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeOnMlsSince",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "propertyLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v0/*: any*/),
            "type": "PropertyLocationWithHiddenAddress",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v0/*: any*/),
            "type": "PropertyLocationWithVisibleAddress",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "priceRangeFormat",
          "value": "SHORT"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PropertyPrice_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertyAttributes_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyPageForSalePropertyListingDetails_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactForSalePropertyAgentButton_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuietPropertyMatchPopup_description_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyLocationMap_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuietPropertyMatchPopup_Agent_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuietPropertyMatchPopup_statusCallout_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UseShouldShowPropertyDetails_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyPageFiles_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClientPagePropertyImageGallery_property"
    },
    {
      "alias": "imageCount",
      "args": null,
      "concreteType": "PropertyImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "fileCount",
      "args": null,
      "concreteType": "PropertyFileConnection",
      "kind": "LinkedField",
      "name": "files",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};
})());

let wrap_fragment_propertyLocation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_propertyLocation = unwrap_fragment_propertyLocation;
exports.wrap_fragment_propertyLocation = wrap_fragment_propertyLocation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
